import React from 'react';

export default ({status, user, applicationId, loadInProgress, type}) => {

  return (
    <section className='scene__scene-header detailsScene__scene-header'>
      <div className='go-back-to-list-header-button' onClick={() => {user.goToFamilyList()}}>Back</div>
      <header>
        {type ? type.componentTypeName : ''} Component Family
      </header>
      {!loadInProgress &&
      <div
        className={`detailsScene__status-label ${status.toLowerCase()}`}>{status.toLowerCase().replace('_', ' ')}
      </div>
      }
    </section>
  );
}



// WEBPACK FOOTER //
// ./src/app/Scenes/ComponentManufacturer/ComponentFamily/Edit/Header.jsx